import http from "./http";
function formatDateParams(data) {
  if (!data) return data;

  const newData = { ...data };
  ["startTime", "endTime"].forEach((key) => {
    if (newData[key]) {
      newData[key] = newData[key].replace(/\//g, "-"); // 把斜杠改成横杠
    }
  });

  return newData;
}
export const getOriginalCurrencyList = (data) => {
  const url = `/api/orderInformation/getOriginalCurrencyList?pageSize=${data.limit}&pageNum=${data.page}`;
  return http.post(url, formatDateParams(data));
};
export const originalCurrencyListExport = (data) => {
  const url = `/api/orderInformation/originalCurrencyListExport?pageSize=${data.limit}&pageNum=${data.page}`;
  return http.post(url, formatDateParams(data));
};
export const playersPlaceBetsGenerateList = (data) => {
  const url = `/api/playersPlaceBets/playersPlaceBetsGenerateList?pageSize=${data.pageSize}&pageNum=${data.pageNum}`;
  return http.post(url);
};
export const playersPlaceBetsGenerate = (data) => {
  const url = `/api/playersPlaceBets/playersPlaceBetsGenerate`;
  return http.post(url, formatDateParams(data));
};
